import React, { createContext, useState, useContext, useEffect } from "react";
import api from "../services/api"; // наш axios-инстанс (настроим позже)

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // При загрузке приложения проверяем, есть ли сохранённый токен
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // Можно попытаться получить данные пользователя (например, GET /api/me)
      api
        .get("/auth/me")
        .then((response) => {
          setUser(response.data);
        })
        .catch(() => {
          // Если токен невалиден — удаляем его
          localStorage.removeItem("token");
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post("/auth/login", { email, password });
      const { token, user } = response.data;
      localStorage.setItem("token", token); // сохраняем токен
      setUser(user);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Ошибка входа",
      };
    }
  };

  const register = async (username, email, password) => {
    try {
      const response = await api.post("/auth/register", {
        username,
        email,
        password,
      });
      const { token, user } = response.data;
      localStorage.setItem("token", token);
      setUser(user);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Ошибка регистрации",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    // Можно также вызвать API для выхода (если нужно)
    // api.post('/auth/logout');
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Хук для использования контекста
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
